import { Component, HostListener, Inject, OnInit, AfterViewInit, OnDestroy } from "@angular/core";
import { DeviceDetectorService } from "ngx-device-detector";
import {_,mySynchEnumeration} from '../../../js/globals';
import { ClientLoggerService } from '../../services/client-logger.service';
import { MySynchDataStore } from "../../data-stores/mysynch.datastore";
import { BroadCastService } from "../../services/broadcast.service";
import { MySynchEnumerationService } from "../../services/mysynch.enumeration.service";
import { MySynchConstantService } from "../../services/mysynch.constant.service";
import { PerformanceMetricsService } from "../../services/performance-metrics.service";
import  { PerformanceContextService } from "../../services/performance-context.service";
import { PerformanceContext } from "../../interfaces/mysynch.interfaces";

@Component({
    standalone: false,
    selector:"site-navigation",
    templateUrl: "../app/navigation/site-navigation/site-navigation.view.html",
})
export class SiteNavigation implements OnInit, AfterViewInit , OnDestroy {
    private _:any;
	private loading:any = true;
    private numFarms:any = 1;
    private hasOnlyNonDC305Farms:any = false; 
    private nonDC305SubmenuNames:any = ["FarmActivities","FarmSettings"];
    private performanceContext: PerformanceContext | null = null;
    private navigationMultiFarmSection:any = {
            name: "MultiFarmSection",
            title: "Multifarm Reports",
            sectionType:"MultiFarm",
            order: 1,
            icon: 'img/material-icons/icons8-barn-withplus-26.png',
            iconType: 'google',
            href:'',
            linkType: 'angular',
            stateName:"",
			includeFarmSelect: false,
            hideFarmSelect: true,
            hasSubMenus: false,
            showTitle: true,
            isHidden: false,
            submenus: [],
            navLinks: [
                {
                    text: 'My Farms',
                    linkType: 'angular',
                    hasIcon: false,
                    icon: '',
                    iconType: '',
                    href: '#/MyFarms',
                    stateName: 'MultiFarmDashboard',
					pageType: 'MultiFarm',
                    navLinkClass: "sidebar-navigation-item",
					isDisabled: false,
                    isHidden: false,
                    allowedHerdSoftware: [
                        "DC305"
                    ],
                    permission: 'MULTIFARM_DASHBOARD_READ'
                }
            ]
        }
        
      
        
    
    private navigationSingleFarmSection:any = {
        name: "SingleFarmSection",
        title: "Single Farm Reports",
        sectionType:"SingleFarm",
        order: 2,
        icon: 'img/material-icons/icons8-barn-24.svg',
        iconType: 'google',
        href:'',
        linkType: 'angular',
        stateName:"",
        includeFarmSelect: true,
        hideFarmSelect: false,
        hasSubMenus: true,
        showTitle: true,
        isHidden: false,
        submenus: [
            {
                name: "Metrics",
                title: "Metrics",
                icon: 'img/material-icons/bar-chart-black-48dp.svg',
                iconType: 'google',
                href: '',
                linkType: '',
                stateName: '',
                collapsed: false,
                isHidden: false,
                allowedHerdSoftware: [
                    "DC305"
                ],
                navLinks: [
                    {
                        text: 'KPI Dashboard',
                        linkType: 'angular',
                        hasIcon: false,
                        icon: '',
                        iconType: '',
                        href: '#/KpiDashboard',
                        stateName: 'KpiDashboard',
                        pageType: 'SingleFarm',
                        isDisabled: false,
                        isHidden: false,
                        allowedHerdSoftware: [
                            "DC305"
                        ],
                        permission: 'KPI_DASHBOARD_READ',
                    },
                    {
                        text: "My Farm's Ranks",
                        linkType: 'angular',
                        hasIcon: false,
                        icon: '',
                        iconType: '',
                        href: '#/MyFarmRanks',
                        stateName: 'MyFarmRanks',
                        pageType: 'SingleFarm',
                        isDisabled: false,
                        isHidden: false,
                        allowedHerdSoftware: [
                            "DC305"
                        ],
                        permission: 'MY_FARM_RANKS_READ',
                    },
                    {
                        text: "Conception Dashboard",
                        linkType: 'angular',
                        hasIcon: false,
                        icon: '',
                        iconType: '',
                        href: '#/ConceptionDashboard',
                        stateName: 'ConceptionDashboard',
                        pageType: 'SingleFarm',
                        isDisabled: false,
                        isHidden: false,
                        allowedHerdSoftware: [],
                        permission: 'CONCEPTION_DASHBOARD_READ',
                    },
                    {
                        text: 'Cohorts',
                        linkType: 'angular',
                        hasIcon: false,
                        icon: '',
                        iconType: '',
                        href: '#/FertilityDashboard',
                        stateName: 'FertilityDashboard',
                        pageType: 'SingleFarm',
                        isDisabled: false,
                        isHidden: false,
                        allowedHerdSoftware: [
                            "DC305"
                        ],
                        requiresFarmInBeta: [
                            "CohortDash_Old"
                        ],
                        permission: 'FERTILITY_DASHBOARD_READ',
                    },
                ]
            }, {
                name: "Trends",
                title: "Trends",
                icon: 'img/material-icons/show-chart-black-48dp.svg',
                iconType: 'google',
                href: '',
                linkType: '',
                stateName: '',
                collapsed: false,
                isHidden: false,
                allowedHerdSoftware: [
                    "DC305"
                ],
                navLinks: [
                    {
                        text: '3-Year Trends',
                        linkType: 'angular',
                        hasIcon: false,
                        icon: '',
                        iconType: '',
                        href: '#/TrendsAndTargets',
                        stateName: 'TrendsAndTargets',
                        pageType: 'SingleFarm',
                        isDisabled: false,
                        isHidden: false,
                        allowedHerdSoftware: [
                            "DC305"
                        ],
                        permission: 'THREE_YEAR_TRENDS_READ',
                    },
                    {
                        text: "Seasonal Trends",
                        linkType: 'angular',
                        hasIcon: false,
                        icon: '',
                        iconType: '',
                        href: '#/SeasonalTrends',
                        stateName: 'SeasonalTrends',
                        pageType: 'SingleFarm',
                        isDisabled: false,
                        isHidden: false,
                        allowedHerdSoftware: [
                            "DC305"
                        ],
                        permission: 'SEASONAL_TRENDS_READ',
                       
                    },
                    {
                        text: 'Fertility Analysis',
                        linkType: 'angular',
                        hasIcon: false,
                        icon: '',
                        iconType: '',
                        href: '#/FertilityAnalysis',
                        stateName: 'FertilityAnalysis',
                        pageType: 'SingleFarm',
                        isDisabled: false,
                        isHidden: false,
                        allowedHerdSoftware: [
                            "DC305"
                        ],
                        permission: 'FERTILITY_ANALYSIS_READ',
                    }
                ]
            },
            {
                name: "FarmActivities",
                title: "Farm Activities",
                icon: 'img/material-icons/add-graph-report-outlined-black-24px.png',
                iconType: 'google',
                href: '',
                linkType: '',
                stateName: '',
                collapsed: false,
                isHidden: false,
                allowedHerdSoftware: [],
                navLinks: [
                    {
                        text: 'Farm Goal Management',
                        linkType: 'angular',
                        hasIcon: false,
                        icon: '',
                        iconType: '',
                        href: '#/FarmGoalManagement',
                        stateName: 'FarmGoalManagement',
                        pageType: 'SingleFarm',
                        isDisabled: false,
                        isHidden: false,
                        permission: 'FARM_GOAL_MANAGEMENT_READ',
                    },
                    {
                        text: "Fertility 360 Report",
                        linkType: 'angular',
                        hasIcon: false,
                        icon: '',
                        iconType: '',
                        href: '#/f360',
                        stateName: 'Fertility360report',
                        pageType: 'SingleFarm',
                        isDisabled: false,
                        isHidden: false,
                        permission: 'F360_DASHBOARD_PUBLISHED_REPORTS_READ',
                    },
                    {
                        text: 'Journal',
                        linkType: 'angular',
                        hasIcon: false,
                        icon: '',
                        iconType: '',
                        href: '#/Journal',
                        stateName: 'Journal',
                        pageType: 'SingleFarm',
                        isDisabled: false,
                        isHidden: false,
                        allowedHerdSoftware: [
                            "DC305"
                        ],
                        permission: 'JOURNAL_READ',
                    }
                ]
            },{
                name:"Reports",
                title:"Reports",
                icon: 'img/material-icons/report-card-outlined-black.png',
                iconType: 'google',
                href: '',
                linkType: '',
                stateName: '',
                collapsed: false,
                isHidden: false,
                allowedHerdSoftware: [],
                navLinks: [
                    {
                        text: 'Benchmark Report',
                        linkType: 'angular',
                        hasIcon: false,
                        icon: '',
                        iconType: '',
                        href: '#/Benchmarking',
                        stateName: 'Benchmarking',
                        pageType: 'SingleFarm',
                        isDisabled: false,
                        isHidden: false,
                        allowedHerdSoftware: [
                            "DC305"
                        ],
                        permission: 'BENCHMARKING_READ',
                    },
                    {
                        text: 'Benchmark App',
                        linkType: 'angular',
                        hasIcon: false,
                        icon: '',
                        iconType: '',
                        href: '#/BenchmarkingApp',
                        stateName: 'BenchmarkingApp',
                        pageType: 'SingleFarm',
                        isDisabled: false,
                        isHidden: false,
                        allowedHerdSoftware: [
                            "DC305"
                        ],
                        permission: 'BENCHMARKING_READ'
                    },
                    {
                        text: 'Special Reports',
                        linkType: 'angular',
                        hasIcon: false,
                        icon: '',
                        iconType: '',
                        href: '#/SpecialReports',
                        stateName: 'SpecialReports',
                        pageType: 'SingleFarm',
                        isDisabled: false,
                        isHidden: false,
                        permission: ''
                    }
                ]
            }
            // , {
            //     name: "Benchmarks",
            //     title: "Benchmarks",
            //     icon: 'img/material-icons/report-card-outlined-black.png',
            //     iconType: 'google',
            //     href: '',
            //     linkType: '',
            //     stateName: '',
            //     collapsed: false,
            //     isHidden: false,
            //     allowedHerdSoftware: [
            //         "DC305"
            //     ],
            //     navLinks: [
            //         {
            //             text: 'Benchmark Report',
            //             linkType: 'angular',
            //             hasIcon: false,
            //             icon: '',
            //             iconType: '',
            //             href: '#/Benchmarking',
            //             stateName: 'Benchmarking',
            //             pageType: 'SingleFarm',
            //             isDisabled: false,
            //             isHidden: false,
            //             allowedHerdSoftware: [
            //                 "DC305"
            //             ],
            //             permission: 'BENCHMARKING_READ',
            //         },
            //     ]
            // }
            , {
                name: "FarmSettings",
                title: "Farm Settings",
                icon: 'img/material-icons/settings-black-48dp.svg',
                iconType: 'google',
                href: '',
                linkType: '',
                stateName: '',
                collapsed: true,
                isHidden: false,
                allowedHerdSoftware: [],
                navLinks: [
                    {
                        text: 'Farm Demographics',
                        linkType: 'angular',
                        hasIcon: false,
                        icon: '',
                        iconType: '',
                        href: '#/FarmAdmin',
                        stateName: 'FarmAdmin',
                        pageType: 'SingleFarm',
                        isDisabled: false,
                        isHidden: false,
                        permission: 'FARM_DEMOGRAPHICS_READ'
                    },
                    // {
                    //     text: "Breeding Codes",
                    //     linkType: 'angular',
                    //     hasIcon: false,
                    //     icon: '',
                    //     iconType: '',
                    //     href: '#/FarmAdmin/breedingcodes',
                    //     stateName: 'BreedingCodes',
                    //     pageType: 'SingleFarm',
                    //     isDisabled: false,
                    //     isHidden: false,
                    //     permission: 'BREEDING_CODES_READ',
                    //     allowedHerdSoftware: [
                    //         "DC305"
                    //     ]
                    // },
                    {
                        text: 'Herd Data',
                        linkType: 'angular',
                        hasIcon: false,
                        icon: '',
                        iconType: '',
                        href: '#/FarmAdmin/herdData',
                        stateName: 'HerdData',
                        pageType: 'SingleFarm',
                        isDisabled: false,
                        isHidden: false,
                        permission: 'HERD_DATA_READ',
                        allowedHerdSoftware: [
                            "DC305"
                        ]
                    },
                    {
                        text: 'User Managment',
                        linkType: 'angular',
                        hasIcon: false,
                        icon: '',
                        iconType: '',
                        href: '#/FarmAdmin/userManagement',
                        stateName: 'UserManagement',
                        pageType: 'SingleFarm',
                        isDisabled: false,
                        isHidden: false,
                        permission: 'USER_MANAGEMENT_READ'
                    },
                    {
                        text: 'Fertility Programs',
                        linkType: 'angular',
                        hasIcon: false,
                        icon: '',
                        iconType: '',
                        href: '#/FertilityCodes',
                        stateName: 'FertilityCodes',
                        pageType: 'SingleFarm',
                        isDisabled: false,
                        isHidden: false,
                        permission: 'COMMON_SETTINGS_READ',
                    },
                    {
                        text: 'Fertility Calendars',
                        linkType: 'angular',
                        hasIcon: false,
                        icon: '',
                        iconType: '',
                        href: '#/FertilityCalendars',
                        stateName: 'FertilityCalendars',
                        pageType: 'SingleFarm',
                        isDisabled: false,
                        isHidden: false,
                        permission: 'COMMON_SETTINGS_READ',
                    },
                ]
            }, {
                name: "EMM",
                title: "eMM",
                icon: 'img/material-icons/vaccines_black_48dp.svg',
                iconType: 'google',
                href: '',
                linkType: '',
                stateName: '',
                collapsed: false,
                isHidden: false,
                requiresFarmInBeta: [
                            "eMM"
                        ],
                navLinks: [
                    {
                        text: 'Retrieve Shot List',
                        linkType: 'angular',
                        hasIcon: false,
                        icon: '',
                        iconType: '',
                        href: '#/eMM/EmmRetrieveShotList',
                        stateName: 'EmmRetrieveShotList',
                        pageType: 'SingleFarm',
                        isDisabled: false,
                        isHidden: false,
                        permission: 'EMM_RETRIEVE_SHOT_LIST_READ',
                    },
                    {
                        text: "Field Reports",
                        linkType: 'angular',
                        hasIcon: false,
                        icon: '',
                        iconType: '',
                        href: '#/eMM/EmmFieldReports',
                        stateName: 'EmmFieldReports',
                        pageType: 'SingleFarm',
                        isDisabled: false,
                        isHidden: false,
                        permission: 'FIELD_REPORTS_READ',
                    }
                ]
            },
        ],
        navLinks: []
    }
    // just the account header links of mobile
    private navigationMobileSection:any =  {
        name: "MobileAccountSection",
        title: "",
        order: 4,
        icon: 'img/material-icons/settings-black-2xDense-48dp.svg',
        iconType: 'google',
        href:'',
		includeFarmSelect: false,
        hideFarmSelect: true,
        hasSubMenus: false,
        showTitle: false,
        isHidden: true,
        submenus: [],
        navLinks: [
            {
                text: 'Education',
                linkType: 'html',
                hasIcon: true,
                icon: 'img/material-icons/school-black-48dp.svg',
                iconType: 'google',
                href: 'https://education.parnell.com/',
                stateName: '',
				pageType: '',
                navLinkClass: "sidebar-navigation-item-profile",
				isDisabled: false,
                isHidden: false,

            },
            {
                text: 'Help',
                linkType: 'angular',
                hasIcon: true,
                icon: 'img/material-icons/help-24px.svg',
                iconType: 'google',
                href: '#/Help',
                stateName: 'Help',
				pageType: '',
                navLinkClass: "sidebar-navigation-item-profile",
				isDisabled: false,
                isHidden: false,

            },
            {
                text: 'User Profile',
                linkType: 'angular',
                hasIcon: true,
                icon: 'img/material-icons/person-outline-black-48dp.svg',
                iconType: 'google',
                href: '#/User',
                stateName: 'User',
				pageType: '',
                navLinkClass: "sidebar-navigation-item-profile",
				isDisabled: false,
                isHidden: false,
                permission: 'USER_PROFILE_READ',

            },
            {
                text: 'Log Out',
                linkType: 'angular',
                hasIcon: true,
                icon: 'img/material-icons/logout-black-48dp.svg',
                iconType: 'google',
                href: '',
                stateName: '',
				pageType: '',
                action:{
                    source: "MSF",
                    function:"logout"
                },
                navLinkClass: "sidebar-navigation-item-profile",
				isDisabled: false,
                isHidden: false,

            }
        ]
    }
    private navigationAdminSection:any = {
        name: "Admin",
        title: "Admin",
        sectionType:"Admin",
        order: 3,
        icon: 'img/material-icons/settings-black-2xDense-48dp.svg',
        iconType: 'google',
        href:"",
        linkType: 'angular',
        stateName:"",
		includeFarmSelect: false,
        hideFarmSelect: true,
        hasSubMenus: true,
        showTitle: false,
        isHidden: false,
        submenus: [
            {
                name: "Admin",
                title: "Admin",
                icon: 'img/material-icons/settings-black-2xDense-48dp.svg',
                iconType: 'google',
                href: '',
                linkType: '',
                stateName: '',
                collapsed: false,
                isHidden: false,
                navLinks: [{
                    text: 'Territory Manager Dashboard',
                    linkType: 'angular',
                    hasIcon: false,
                    icon: '',
                    iconType: '',
                    href: '#/admin/TerritoryDashboard',
                    stateName: 'TerritoryDashboard',
                    optionalStateParams: {
                        selectedTabName: this.mySynchConstantSvc.defaultTerritoryManagerDashboardTab
                    },
					pageType: 'Admin',
					isDisabled: false,
                    isHidden: false,
					roles:[this.mySynchEnumSvc.getMySynchEnumeration('Role','TERRITORY_MANAGER')],
                    permission: 'TM_DASHBOARD_READ',
    
                },
                {
                    text: 'Farm Management',
                    linkType: 'angular',
                    hasIcon: false,
                    icon: '',
                    iconType: '',
                    href: '#/admin/FarmManagement',
                    stateName: 'FarmManagement',
					pageType: 'Admin',
					isDisabled: false,
                    isHidden: false,
					roles:[this.mySynchEnumSvc.getMySynchEnumeration('Role','SUPER_ADMIN'),this.mySynchEnumSvc.getMySynchEnumeration('Role','PARNELL_VIEWER')],
                    permission: 'ADMIN_FARM_MANAGEMENT_READ',
    
                },
                {
                    text: 'User Management',
                    linkType: 'angular',
                    hasIcon: false,
                    icon: '',
                    iconType: '',
                    href: '#/admin/AdminUserManagement',
                    stateName: 'AdminUserManagement',
					pageType: 'Admin',
					isDisabled: false,
                    isHidden: false,
					roles:[this.mySynchEnumSvc.getMySynchEnumeration('Role','SUPER_ADMIN'),this.mySynchEnumSvc.getMySynchEnumeration('Role','PARNELL_VIEWER')],
                    permission: 'ADMIN_USER_MANAGEMENT_READ',
    
                },
                {
                    text: "Internal Tools",
                    linkType: 'html',
                    hasIcon: false,
                    icon: '',
                    iconType: '',
                    href: 'https://internaltools.duckdns.org/',
                    stateName: '',
                    pageType: '',
                    isDisabled: false,
                    isHidden: false,
                    roles:[this.mySynchEnumSvc.getMySynchEnumeration('Role','SUPER_ADMIN')],
                }
            ]
            }
        ],
        navLinks: [
            
        ]
    }
    private currentNavLinkView:any = [];
    private currentCollpasedNavLinkView:any = [];
    private collapsedNavLinkViewItemTmp:any ={
        name:'',
        icon: '',
        iconType: '',
        text: '',
        href:'',
        linkType:'',
        stateName: '',
        isHidden:false,
		requiresFarmInBeta: []
     }
    private navigationIsCollapsed:boolean = false;
	private navigationCollapsedWidth:string = "86px";
    private navigationMobileCollaspedWidth:string = "0px";
	private navigationExpandedWidth:string = "273px";

	
	private isSuperAdmin:any = this.viewAuth.hasRole(this.mySynchEnumSvc.getMySynchEnumeration('Role','SUPER_ADMIN'));
    private isParnellViewer:any = this.viewAuth.hasRole(this.mySynchEnumSvc.getMySynchEnumeration('Role','PARNELL_VIEWER'));
	private isTM:any = this.viewAuth.hasRole(this.mySynchEnumSvc.getMySynchEnumeration('Role','TERRITORY_MANAGER'));
	private isUser:any = (!this.isSuperAdmin && !this.isParnellViewer && !this.isTM) ? true : false;
    private currentHerd:any;

    private isMobile:boolean = this.deviceDetector.isMobile();

    private noRedirectPages:any = ['Login', 'Welcome', 'WelcomeToFarm', 'ForgotPassword', 'PasswordReset','User','Alerts','NewJournal','JournalEdit','Definitions','Help'];

    // subscriptions and deregistrations
    private currentUserSubscription:any;
    private onUpdateNavigationSubscription:any;
    private onToggleNavigationSubscription:any;

	/////////////////////////////////////////////////////////////
			/* 
               Code Imported From Farm Header
			*/
         

           private weatherUnits:any = [
				{name: 'imperial',	symbol: 'F'},
				{name: 'metric',	symbol: 'C'}
			];
            private chosenWeatherUnit:any = this.weatherUnits[0];
			private weatherData:any = null;
          

    constructor(@Inject('MySynchFactory') private MSF:any, 
                @Inject(MySynchDataStore) private mysynchDataStore:MySynchDataStore,
                @Inject(BroadCastService) private broadCastSrv:BroadCastService,
                @Inject(MySynchEnumerationService) private mySynchEnumSvc:MySynchEnumerationService,
                @Inject(MySynchConstantService) private mySynchConstantSvc:MySynchConstantService,
                @Inject('ViewAuthorizationFactory') private viewAuth:any,
                @Inject('ApiFactory') private api:any,
                @Inject('F360Constant') private constant:any,
                @Inject('IndexedDBFactory') private indexedDB:any,
                @Inject(DeviceDetectorService) private deviceDetector:DeviceDetectorService,
                @Inject(PerformanceMetricsService) private perfMetricSvc:PerformanceMetricsService,
                @Inject(ClientLoggerService) private log:ClientLoggerService,
                @Inject(PerformanceContextService) private perfContextSvc: PerformanceContextService,){

            this._ = _;
       if(this.isMobile){
          this.navigationIsCollapsed = true;
       }
    }

          

	       private toggleNavgigation(scrollToMenu:any = undefined){

            var sideBarContainer = $(".site-sidebar-outer-container");
            var sidebarContainerExpandProperties = {};
            var sidebarContainerCollapseProperties = {};
            var sidebarContainerExpandWidth = "";
          
            if(this.isMobile){
                sideBarContainer = $("#siteNavigationMobile")
                sidebarContainerExpandWidth = $('html').outerWidth(true)+"px";
                sidebarContainerExpandProperties = {"flex-basis":sidebarContainerExpandWidth,"width":sidebarContainerExpandWidth};
                sidebarContainerCollapseProperties = {"flex-basis":this.navigationMobileCollaspedWidth,"width":this.navigationMobileCollaspedWidth};
                
            }else{
                sidebarContainerExpandWidth = this.navigationExpandedWidth;
                sidebarContainerExpandProperties = {"flex-basis":sidebarContainerExpandWidth};
                sidebarContainerCollapseProperties = {"flex-basis":this.navigationCollapsedWidth};
            }

			var sidebarNav = $(".sidebar-nav");
			 if(this.navigationIsCollapsed){
				this.navigationIsCollapsed = !this.navigationIsCollapsed;

                if(this.isMobile){
                   sideBarContainer.addClass("site-navigation-mobile-expanded-background");
                }

				sideBarContainer.animate(sidebarContainerExpandProperties,400,()=>{
				});
			   
				sidebarNav.animate({width:  this.navigationExpandedWidth},400,()=>{
				   
				   if(!this._.isUndefined(scrollToMenu)){
					var menuJObj = $("#submenu-"+scrollToMenu);
					var menuColCtrl = $("#submenu-collapse-control-"+scrollToMenu);
					
					if(!this._.isUndefined(menuJObj[0]) && !this._.isUndefined(menuColCtrl[0])){
						var menuIsCollapsed = menuColCtrl.hasClass("collapsed");
					
							if(menuIsCollapsed){
								menuColCtrl.trigger('click');
							}
							$(".sidebar-nav").animate({
								scrollTop: menuJObj.offset().top - (sidebarNav.offset().top + sidebarNav.scrollTop())
							},400,()=>{
								
							})
					
						   
					}
					
				}
				});
			 }else{
				this.navigationIsCollapsed = !this.navigationIsCollapsed;
                var collapsedWidth = (this.isMobile) ? this.navigationMobileCollaspedWidth : this.navigationCollapsedWidth;

                if(this.isMobile){
                    sideBarContainer.removeClass("site-navigation-mobile-expanded-background");
                 }
				sideBarContainer.animate(sidebarContainerCollapseProperties,400,()=>{
				});
			   
				sidebarNav.animate({width: collapsedWidth},400,()=>{
				});
			 }
			    
		   }

           private goToMySynchLandingPage(){
                var homepage =  this.MSF.getUserHomepageStateName()
                this.MSF.loadPage(homepage); 
                this.toggleNavgigation();  
           }
    

	       
			/////////////////////////////////////////////////////////////
			/* 
               Code Imported From Farm Header
			*/


			private fetchWeather(zip) {
				// temporarily disabled since the weather api doesnt have a secure version
				/*
				weather.get(zip, $s.chosenWeatherUnit.name).then(function gotWeather(data) {
					$s.weatherData = data;
				});
				*/
			}


			private refresh() {
				var currentFarm = this.MSF.getActiveFarm();
						
				if (!_.isEmpty(currentFarm)) {
				
					this.fetchWeather(currentFarm.postalCode);
				} else {
			
					this.weatherData = null;
				}		

			};


   			/////////////////////////////////////////////////////////////

			
			private checkRole(requiredRoles){
				return !requiredRoles || this.viewAuth.hasRole(requiredRoles)
			}
			private checkRolePermission(requiredPermission) {
				return !requiredPermission || this.viewAuth.hasPermission(this.mySynchEnumSvc.getMySynchEnumerationName("Permission",requiredPermission));
			};
			private checkHerdSofwarePermission(allowedHerdSoftware){
				return this.viewAuth.hasHerdSoftwarePermission(allowedHerdSoftware);
			};
			private checkFarmInBeta(requiredBetas){
				return this.viewAuth.farmIsInBeta(requiredBetas);
			};

			private getFilteredNavLinksByPermisson() {
				return _.filter(this.currentNavLinkView.navLinks,(navLink:any) => {
					return (_.compact(_.map(_.map(navLink.dropdown, 'permission'), this.checkRolePermission)).length || this.checkRolePermission(navLink.permission))
						&& this.checkHerdSofwarePermission(_.get(navLink,'allowedHerdSoftware'));
				});
			};

            private getMultiFarmNavView(){
                var multifarmView = _.cloneDeep(this.navigationMultiFarmSection);
                if(_.isEqual(this.numFarms,1) || this.hasOnlyNonDC305Farms){
                    _.set(multifarmView,'isHidden',true);
                }
                return multifarmView;
            }
            private getSingleFarmNavView(){
                var singleFarmView = _.cloneDeep(this.navigationSingleFarmSection);
               
                if(_.isEqual(this.numFarms,1) ){
                    _.set(singleFarmView,'showTitle',false);
                    _.set(singleFarmView,'hideFarmSelect',true);
                }

               // all non dc305 users will only have a subset of the submenus of "SingleFarmReports" section
                if(this.hasOnlyNonDC305Farms || !this._.isEqual(this._.get(this.MSF.getActiveHerd(),'herdMgmtSoftware'),"DC305")){
                   _.forEach(singleFarmView.submenus,(submenu)=>{
                       //_.includes(this.nonDC305SubmenuNames,_.get(submenu,'name'));
                       if(_.includes(_.get(submenu,'allowedHerdSoftware',[]),"DC305") && !_.includes(_.get(submenu,'allowedHerdSoftware',[]),_.get(this.MSF.getActiveHerd(),'herdMgmtSoftware'))){
                         _.set(submenu,'isHidden',true);
                       }                      
                   })    
                }

                // hide the submenu if all of the links in the submenu are hidden
                _.forEach(singleFarmView.submenus,(submenu)=>{
                    if(_.every(_.get(submenu,"navLinks",[]),(navLink:any)=>{
                                                                        var linkVisible = this.checkRole(_.get(navLink,'roles')) && this.checkFarmInBeta(_.get(navLink,'requiresFarmInBeta')) && this.checkRolePermission(_.get(navLink,'permission'));
                                                                        return !linkVisible;
                                                                    }
                              )
                      ){
                         _.set(submenu,'isHidden',true);
                       }
                });
                if(this.isMobile){
                    _.forEach(singleFarmView.submenus,(submenu)=>{
                        _.set(submenu,'collapsed',true);
                    });
                }

                return singleFarmView;
            }
            private getAdminSectionView(){
                var adminSectionView = _.cloneDeep(this.navigationAdminSection);
                if(this.isUser){
                    _.set(adminSectionView,'isHidden',true);
                }
                return adminSectionView;
            }
            private getNavigationMobileSectionView(){
                var navigationMobileSectionView  = _.cloneDeep(this.navigationMobileSection);
                if(this.isMobile){
                    _.set(navigationMobileSectionView,'isHidden',false);
                }
                return navigationMobileSectionView;
            }
            // function that builds the currentNavLinkView
			private buildNavLinkView(){
				
                var multifarmView = this.getMultiFarmNavView();
                var singleFarmView = this.getSingleFarmNavView(); 
                var adminSectionView = this.getAdminSectionView();
                var navigationMobileSectionView = this.getNavigationMobileSectionView();
                this.currentNavLinkView = [multifarmView,singleFarmView,adminSectionView,navigationMobileSectionView];
                this.checkCurrentPageIsInNavigation();   	 
			};
            private getCollapsedMultFarmNavView(){
                var collapsedMultiFarmView = [];

                var multifarmView = this.getMultiFarmNavView();
                var singleFarmView = this.getSingleFarmNavView(); 
              
                var navLinkView = [multifarmView,singleFarmView];
                _.forEach(navLinkView,(section)=>{
                    var collapsedNavLinkViewItem = _.cloneDeep(this.collapsedNavLinkViewItemTmp);
                    _.set(collapsedNavLinkViewItem,'name', _.get(section,'name'));
                    _.set(collapsedNavLinkViewItem,'icon',_.get(section,'icon'));
                    _.set(collapsedNavLinkViewItem,'iconType',_.get(section,'iconType'));
                    _.set(collapsedNavLinkViewItem,'text',_.get(section,'title'));
                    _.set(collapsedNavLinkViewItem,'href',_.get(section,'href'));
                    _.set(collapsedNavLinkViewItem,'linkType',_.get(section,'linkType'));
                    _.set(collapsedNavLinkViewItem,'stateName',_.get(section,'stateName'));
                    _.set(collapsedNavLinkViewItem,'requiresFarmInBeta',_.get(section,'requiresFarmInBeta',[]));

                    if(this.numFarms == 1 || this.hasOnlyNonDC305Farms){
                        _.set(collapsedNavLinkViewItem,'isHidden',true);
                    }

                    collapsedMultiFarmView.push(collapsedNavLinkViewItem);
                });
                return collapsedMultiFarmView;
            }
            private getCollapsedSingleFarmNavView(){
                var collapsedSingleFarmView = [];
                var singleFarmView = this.getSingleFarmNavView(); 

              
                _.forEach(_.get(singleFarmView,'submenus'),(submenu)=>{
                    var collapsedNavLinkViewItem = _.cloneDeep(this.collapsedNavLinkViewItemTmp);
                    _.set(collapsedNavLinkViewItem,'name', _.get(submenu,'name'));
                    _.set(collapsedNavLinkViewItem,'icon',_.get(submenu,'icon'));
                    _.set(collapsedNavLinkViewItem,'iconType',_.get(submenu,'iconType'));
                    _.set(collapsedNavLinkViewItem,'text',_.get(submenu,'title'));
                    _.set(collapsedNavLinkViewItem,'href',_.get(submenu,'href'));
                    _.set(collapsedNavLinkViewItem,'linkType',_.get(submenu,'linkType'));
                    _.set(collapsedNavLinkViewItem,'stateName',_.get(submenu,'stateName'));
                    _.set(collapsedNavLinkViewItem,'requiresFarmInBeta',_.get(submenu,'requiresFarmInBeta',[]));

                    if(this.numFarms > 1 ){
                        
                        _.set(collapsedNavLinkViewItem,'isHidden',true);
                    }

                    if(this.hasOnlyNonDC305Farms || !this._.isEqual(_.get(this.MSF.getActiveHerd(),'herdMgmtSoftware'),"DC305")){
                        // need to hide non dc305 submenus
                        if(_.includes(_.get(submenu,'allowedHerdSoftware',[]),"DC305") && !_.includes(_.get(submenu,'allowedHerdSoftware',[]),_.get(this.MSF.getActiveHerd(),'herdMgmtSoftware'))){
                            _.set(collapsedNavLinkViewItem,'isHidden',true);
                        }
                    }

                    collapsedSingleFarmView.push(collapsedNavLinkViewItem);
                })
                 
              
                return collapsedSingleFarmView;
            }
            private getCollapsedAdminSectionView(){
                var collapsedAdminView = [];
                var adminSectionView = this.getAdminSectionView();

                _.forEach(_.get(adminSectionView,'submenus'),(submenu)=>{
                    var collapsedNavLinkViewItem = _.cloneDeep(this.collapsedNavLinkViewItemTmp);
                    _.set(collapsedNavLinkViewItem,'name', _.get(submenu,'name'));
                    _.set(collapsedNavLinkViewItem,'icon',_.get(submenu,'icon'));
                    _.set(collapsedNavLinkViewItem,'iconType',_.get(submenu,'iconType'));
                    _.set(collapsedNavLinkViewItem,'text',_.get(submenu,'title'));
                    _.set(collapsedNavLinkViewItem,'href',_.get(submenu,'href'));
                    _.set(collapsedNavLinkViewItem,'linkType',_.get(submenu,'linkType'));
                    _.set(collapsedNavLinkViewItem,'stateName',_.get(submenu,'stateName'));
                    _.set(collapsedNavLinkViewItem,'requiresFarmInBeta',_.get(submenu,'requiresFarmInBeta',[]));

                    if(this.isUser){
                        _.set(collapsedNavLinkViewItem,'isHidden',true);
                    }

                    collapsedAdminView.push(collapsedNavLinkViewItem);
                })
                 
                return collapsedAdminView;
            }

            private buildCollapsedNavLinkView(){
                // users with multiple farms, PAs and TMs  and not only non-dc305 farms

                var collapsedMultiFarmView = this.getCollapsedMultFarmNavView();
                var collapsedSingleFarmView = this.getCollapsedSingleFarmNavView(); 
                var collapsedAdminView = this.getCollapsedAdminSectionView();
                this.currentCollpasedNavLinkView = _.union(collapsedMultiFarmView,collapsedSingleFarmView,collapsedAdminView);

            }

            private checkCurrentPageIsInNavigation(){
                var navLinkStates = [];
                 _.forEach(this.currentNavLinkView,(section)=>{
                        //var statesInSectionNavLinks = _.pluck(_.get(section,'navLinks',[]),'stateName');
                        var statesInSectionNavLinks = _.map(_.get(section,'navLinks',[]),(navLink)=>_.pick(navLink,["isHidden","stateName"]));
                        var statesInSubMenuNavLinks = _.flattenDeep(
                                                            _.map(_.cloneDeep(_.get(section,'submenus',[])),(submenu)=>{
                                                                return _.map(_.get(submenu,'navLinks',[]),(navLink)=>_.pick(navLink,["isHidden","stateName"]));
                                                            })
                                                      );
                        navLinkStates.push(statesInSectionNavLinks)
                        navLinkStates.push(statesInSubMenuNavLinks);
                 });

                 navLinkStates = _.uniq(_.compact(_.flattenDeep(navLinkStates)));
 
                 if(!_.isEmpty(this.MSF.state.current.name) && !_.any(navLinkStates,(navLinkState)=>{ return _.isEqual(this.MSF.state.current.name,_.get(navLinkState,'stateName')) && !_.get(navLinkState,'isHidden',false)}) && !_.includes(this.noRedirectPages,this.MSF.state.current.name)){
                    console.log("@@@ redirecting to Home Page form Site Nav @@@");
                    this.redirectToHomepage();
                 }
            }

            private updateNavSectionView(sectionName:string){
               
                var sectionToUpdate = _.find(this.currentNavLinkView,{name: sectionName});

                
                switch (sectionName) {
                    case _.get(this.navigationMultiFarmSection,'name'):       
                       var multiFarmNavView = this.getMultiFarmNavView(); 
                        _.set(sectionToUpdate,'isHidden',_.get(multiFarmNavView,'isHidden'));            
                        break;
                    case _.get(this.navigationSingleFarmSection,'name'): 
                        var singleFarmNavView = this.getSingleFarmNavView();
                        _.set(sectionToUpdate,'showTitle',_.get(singleFarmNavView,'showTitle')); 
                        _.set(sectionToUpdate,'hideFarmSelect',_.get(singleFarmNavView,'hideFarmSelect')); 
                        break;
                    case _.get(this.navigationAdminSection,'name'): 
                        var adminNavView = this.getAdminSectionView();
                        _.set(sectionToUpdate,'isHidden',_.get(adminNavView,'isHidden')); 
                        break;
                }
                       
                this.checkCurrentPageIsInNavigation();   
            }

            private resetViews(){
                this.currentNavLinkView = [];
                this.currentCollpasedNavLinkView = [];
            }

            private redirectToHomepage(){
                var homepage =  this.MSF.getUserHomepageStateName()
                this.MSF.loadPage(homepage);   
                 
            }

            private setOrUpdateNavDeterminationProperties(){
                this.currentHerd = this.MSF.getActiveHerd();
                this.isSuperAdmin = this.viewAuth.hasRole(this.mySynchEnumSvc.getMySynchEnumeration('Role','SUPER_ADMIN'));
                this.isParnellViewer = this.viewAuth.hasRole(this.mySynchEnumSvc.getMySynchEnumeration('Role','PARNELL_VIEWER'));
                this.isTM = this.viewAuth.hasRole(this.mySynchEnumSvc.getMySynchEnumeration('Role','TERRITORY_MANAGER'));
                this.isUser = (!this.isSuperAdmin && !this.isParnellViewer && !this.isTM) ? true : false;
                var availableFarms = this.MSF.getAvailableFarms();
                this.numFarms = _.get(availableFarms,"length",1);
                
                this.hasOnlyNonDC305Farms = this.MSF.userHasOnlyNonDC305Farms();
            }
           
			private setNavigationMaxHeight(){

                var headerSubstraction = (this.isMobile) ? 0 : 62;
				
				var htmlRoot = $("html");
                $(".sidebar-nav").css({"maxHeight":htmlRoot.outerHeight(true)-headerSubstraction+"px","overflow-y":"auto"});
				$(".sidebar-nav-collapse-btn").removeClass("dis-none");
				$("#siteNavigation").css({"overflow-y":"unset"});
				
            }

			private refreshNavigationMaxHeight(){
                var headerSubstraction = (this.isMobile) ? 0 : 62;
				var htmlRoot = $("html");
                $(".sidebar-nav").css({"maxHeight":htmlRoot.outerHeight(true)-headerSubstraction+"px","overflow-y":"auto"});
			}

            private navigationOnClick(event){
               var eventTarget = _.get(event,'target') as any;
               if(!_.isUndefined(eventTarget) && $("#siteNavigation").is(eventTarget) && this.isMobile){
                 this.toggleNavgigation();
               }
            }

		   ngOnDestroy(): void {
                if(this.currentUserSubscription){
                    this.currentUserSubscription.unsubscribe();
                }
                if(this.onUpdateNavigationSubscription){
                    this.onUpdateNavigationSubscription.unsubscribe();
                }
                if(this.onToggleNavigationSubscription){
                    this.onToggleNavigationSubscription.unsubscribe();
                }
               this.performanceContext = null;
           }

           ngOnInit(){
                

            this.MSF.ready(()=>{
                this.performanceContext = this.perfContextSvc.createPerformanceContext();
                this.perfMetricSvc.startTiming("Component:SiteNavigation:Render");
                
                this.setNavigationMaxHeight();
                
                var currentFarm = this.MSF.getActiveFarm();
                

                this.refresh(); 

                this.setOrUpdateNavDeterminationProperties();

                this.buildNavLinkView();
                this.buildCollapsedNavLinkView();

                this.loading = false;

              this.currentUserSubscription = this.mysynchDataStore.currentUser
                    .subscribe((user)=>{
                        if(!this.MSF.isNullish(user) && !this.loading){
                            this.refresh();      
                        }
                    });

              this.onUpdateNavigationSubscription = this.broadCastSrv.onUpdateNavigation()
                    .subscribe((msgData)=>{
                        this.setOrUpdateNavDeterminationProperties(); 
                        this.buildCollapsedNavLinkView();          
                    });

               this.onToggleNavigationSubscription = this.broadCastSrv.onToggleNavigation()
                    .subscribe((msgData)=>{
                        this.toggleNavgigation();
                    });

            });
                         
        }

        ngAfterViewInit(){
              this.MSF.ready(()=>{
                this.perfMetricSvc.endTiming("component","Component:SiteNavigation:Render",this.performanceContext);
              });
        }
    

        @HostListener('window:resize', ['$event'])
        onResize(event) {
        //console.log("window resize event fired")
            this.refreshNavigationMaxHeight();
        }
           
		


			

			
			
		
		

}